// extracted by mini-css-extract-plugin
export default {"navDrawer":"taggedWorkflowMenuDrawer_navDrawer__pqBkW"};